import type { Account } from "../../../../shared/domains/account/account";
import { getAvailableBalance } from "../../../../shared/domains/account/account";
import { getTotalOfDetailedAccounting } from "../../../../shared/utils/total-amount";

export const isOverdraftMatchingBalance = (account: Account, authorizedOverdraftValue: number): boolean => {
  const availableBalance = getAvailableBalance(account)?.value;

  // If the available balance is negative and equals the absolute value of the overdraft
  if (availableBalance < 0 && availableBalance === -authorizedOverdraftValue) {
    return true;
  }

  return false;
};

export function isPositiveDetailedAccounting(detailedAccounting: { amount: { value: number } }[]): boolean {
  return getTotalOfDetailedAccounting(detailedAccounting) > 0;
}
